var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.users
      ? _c("table", { staticClass: "table table-sm table-hover" }, [
          _c(
            "tbody",
            [
              _vm._l(_vm.getSortedDivision(), function (div, index) {
                return [
                  _c("tr", { staticClass: "division_info" }, [
                    _c("td", { attrs: { colspan: "10" } }, [
                      _c(
                        "div",
                        { staticClass: "flex justify-content-between" },
                        [
                          _c(
                            "div",
                            [
                              _c("span", [_vm._v(_vm._s(div.title))]),
                              _vm._v(" \n              "),
                              _vm._l(div.cities ?? [], function (city, index) {
                                return _c("span", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(index > 0 ? ", " : "") +
                                      " " +
                                      _vm._s(
                                        city?.city?.name ?? "почтовые города"
                                      ) +
                                      "\n          "
                                  ),
                                ])
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("(ID:" + _vm._s(div.id) + ")"),
                              ]),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.allowToHideDivUsers.includes(div.id)
                            ? _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    on: {
                                      click: function ($event) {
                                        _vm.hideDivUsers[div.id] =
                                          !_vm.hideDivUsers[div.id]
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.hideDivUsers[div.id]
                                            ? "Показать"
                                            : "Скрыть"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  !_vm.hideDivUsers[div.id]
                    ? [
                        (_vm.users[div.id]?.chief ?? []).length
                          ? _vm._l(
                              _vm.users[div.id].chief,
                              function (r, index1) {
                                return _c("tr", [
                                  _c("td", { attrs: { width: "50px" } }, [
                                    _vm._v(_vm._s(index1 + 1)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(r.name) +
                                          " (" +
                                          _vm._s(r.login) +
                                          ") (" +
                                          _vm._s(r.id) +
                                          ")"
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.userDetails[r.id] &&
                                      _vm.userDetails[r.id]
                                        .telegram_chat_data &&
                                      _vm.userDetails[r.id].telegram_chat_data
                                        .details.chat_id
                                        ? [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-paper-plane color_blue",
                                            }),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.userDetails[r.id] &&
                                      _vm.userDetails[r.id].tablet_imei
                                        ? [
                                            !_vm.popover[r.id].imei
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-outline-info",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.popover[
                                                          r.id
                                                        ].imei = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.userDetails[r.id]
                                                            .tablet_imei.details
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.popover[r.id].imei
                                              ? _c(
                                                  "v-popover",
                                                  {
                                                    attrs: {
                                                      popoverClass:
                                                        "popover_white",
                                                      "auto-hide": true,
                                                      open:
                                                        _vm.popover[r.id] &&
                                                        _vm.popover[r.id].imei,
                                                    },
                                                    on: {
                                                      hide: function ($event) {
                                                        return _vm.destroyPopover(
                                                          r.id,
                                                          "imei"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-xs btn-outline-info",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.userDetails[
                                                                r.id
                                                              ].tablet_imei
                                                                .details
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "popover" },
                                                      [
                                                        _c("div", [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Редактирование устройства"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "LoadingButton",
                                                                {
                                                                  attrs: {
                                                                    title:
                                                                      "Отвязать IMEI",
                                                                    className:
                                                                      "btn btn-warning btn-xs mb-1",
                                                                    onClick:
                                                                      () =>
                                                                        _vm.updateUser(
                                                                          r.id,
                                                                          "imei",
                                                                          "disable_imei"
                                                                        ),
                                                                    loading:
                                                                      _vm.btnLoading,
                                                                    color:
                                                                      "white",
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "LoadingButton",
                                                                {
                                                                  attrs: {
                                                                    title:
                                                                      "Отозвать сертификат",
                                                                    className:
                                                                      "btn btn-warning btn-xs",
                                                                    onClick:
                                                                      () =>
                                                                        _vm.updateUser(
                                                                          r.id,
                                                                          "imei",
                                                                          "disable_tablet_certificate"
                                                                        ),
                                                                    loading:
                                                                      _vm.btnLoading,
                                                                    color:
                                                                      "white",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.userInfoMessage(r.id)
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex justify-content-end",
                                      },
                                      [
                                        _vm.popover[r.id] &&
                                        !_vm.popover[r.id].disable &&
                                        (!r.orders || !r.orders.length)
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-xs btn-outline-warning mr-1",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.popover[
                                                      r.id
                                                    ].disable = true
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  В архив\n                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.popover[r.id] &&
                                        _vm.popover[r.id].disable
                                          ? _c(
                                              "v-popover",
                                              {
                                                attrs: {
                                                  popoverClass: "popover_white",
                                                  "auto-hide": true,
                                                  open:
                                                    _vm.popover[r.id] &&
                                                    _vm.popover[r.id].disable,
                                                },
                                                on: {
                                                  hide: function ($event) {
                                                    return _vm.destroyPopover(
                                                      r.id,
                                                      "disable"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-outline-warning mr-1",
                                                    attrs: { type: "button" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    В архив\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "template",
                                                  { slot: "popover" },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-1" },
                                                        [
                                                          _vm._v(
                                                            "Отправить курьера"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-1" },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(r.name)
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-1" },
                                                        [_vm._v("в архив?")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        [
                                                          _c("LoadingButton", {
                                                            attrs: {
                                                              title: "в архив",
                                                              className:
                                                                "btn btn-warning btn-xs",
                                                              onClick: () =>
                                                                _vm.updateUser(
                                                                  r.id,
                                                                  "disable"
                                                                ),
                                                              loading:
                                                                _vm.btnLoading,
                                                              color: "white",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.editUser
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-info pull-right",
                                            on: {
                                              click: function ($event) {
                                                return _vm.editUser(r)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-eye",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ])
                              }
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.users[div.id]?.runners ?? []).length
                          ? _vm._l(
                              _vm.users[div.id].runners,
                              function (r, index2) {
                                return _c("tr", [
                                  _c("td", { attrs: { width: "50px" } }, [
                                    _vm._v(
                                      _vm._s(
                                        ((_vm.users[div.id]?.chief ?? [])
                                          .length ?? 0) +
                                          1 +
                                          index2
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(r.name) +
                                        " (" +
                                        _vm._s(r.login) +
                                        ") (" +
                                        _vm._s(r.id) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.userDetails[r.id] &&
                                      _vm.userDetails[r.id]
                                        .telegram_chat_data &&
                                      _vm.userDetails[r.id].telegram_chat_data
                                        .details.chat_id
                                        ? [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-paper-plane color_blue",
                                            }),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm.userDetails[r.id] &&
                                      _vm.userDetails[r.id].tablet_imei
                                        ? [
                                            !_vm.popover[r.id].imei
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-outline-info",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.popover[
                                                          r.id
                                                        ].imei = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.userDetails[r.id]
                                                            .tablet_imei.details
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.popover[r.id].imei
                                              ? _c(
                                                  "v-popover",
                                                  {
                                                    attrs: {
                                                      popoverClass:
                                                        "popover_white",
                                                      "auto-hide": true,
                                                      open:
                                                        _vm.popover[r.id] &&
                                                        _vm.popover[r.id].imei,
                                                    },
                                                    on: {
                                                      hide: function ($event) {
                                                        return _vm.destroyPopover(
                                                          r.id,
                                                          "imei"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-xs btn-outline-info",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.userDetails[
                                                                r.id
                                                              ].tablet_imei
                                                                .details
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "popover" },
                                                      [
                                                        _c("div", [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Редактирование устройства"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "LoadingButton",
                                                                {
                                                                  attrs: {
                                                                    title:
                                                                      "Отвязать IMEI",
                                                                    className:
                                                                      "btn btn-warning btn-xs mb-1",
                                                                    onClick:
                                                                      () =>
                                                                        _vm.updateUser(
                                                                          r.id,
                                                                          "imei",
                                                                          "disable_imei"
                                                                        ),
                                                                    loading:
                                                                      _vm.btnLoading,
                                                                    color:
                                                                      "white",
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "LoadingButton",
                                                                {
                                                                  attrs: {
                                                                    title:
                                                                      "Отозвать сертификат",
                                                                    className:
                                                                      "btn btn-warning btn-xs",
                                                                    onClick:
                                                                      () =>
                                                                        _vm.updateUser(
                                                                          r.id,
                                                                          "imei",
                                                                          "disable_tablet_certificate"
                                                                        ),
                                                                    loading:
                                                                      _vm.btnLoading,
                                                                    color:
                                                                      "white",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.userInfoMessage(r.id)
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex justify-content-end",
                                      },
                                      [
                                        _vm.popover[r.id] &&
                                        !_vm.popover[r.id].disable &&
                                        (!r.orders || !r.orders.length)
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-xs btn-outline-warning mr-1",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.popover[
                                                      r.id
                                                    ].disable = true
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  В архив\n                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.popover[r.id] &&
                                        _vm.popover[r.id].disable
                                          ? _c(
                                              "v-popover",
                                              {
                                                attrs: {
                                                  popoverClass: "popover_white",
                                                  "auto-hide": true,
                                                  open:
                                                    _vm.popover[r.id] &&
                                                    _vm.popover[r.id].disable,
                                                },
                                                on: {
                                                  hide: function ($event) {
                                                    return _vm.destroyPopover(
                                                      r.id,
                                                      "disable"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-xs btn-outline-warning mr-1",
                                                    attrs: { type: "button" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    В архив\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "template",
                                                  { slot: "popover" },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-1" },
                                                        [
                                                          _vm._v(
                                                            "Отправить курьера"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-1" },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(r.name)
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-1" },
                                                        [_vm._v("в архив?")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        [
                                                          _c("LoadingButton", {
                                                            attrs: {
                                                              title: "в архив",
                                                              className:
                                                                "btn btn-warning btn-xs",
                                                              onClick: () =>
                                                                _vm.updateUser(
                                                                  r.id,
                                                                  "disable"
                                                                ),
                                                              loading:
                                                                _vm.btnLoading,
                                                              color: "white",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.editUser
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-info pull-right",
                                            on: {
                                              click: function ($event) {
                                                return _vm.editUser(r)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-eye",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ])
                              }
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("h5", [_vm._v("Курьеры без дивизиона и не активные")]),
    _vm._v(" "),
    _c("table", { staticClass: "table table-hover table-sm" }, [
      _c(
        "tbody",
        [
          _vm.unlinkedUsers && _vm.unlinkedUsers.length
            ? [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.unlinkedUsers, function (r, index) {
                  return _c("tr", [
                    _c("td", { attrs: { width: "50px" } }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(r.name) + " (" + _vm._s(r.login) + ")"),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm.editUser
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-xs btn-info pull-right",
                              on: {
                                click: function ($event) {
                                  return _vm.editUser(r)
                                },
                              },
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                          )
                        : _vm._e(),
                    ]),
                  ])
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.inactiveUsers && _vm.inactiveUsers.length
            ? [
                _c("tr", { staticClass: "division_info" }, [
                  _c("td", { attrs: { colspan: "10" } }, [
                    _c("div", { staticClass: "flex justify-content-between" }, [
                      _c("div", [_vm._v("Курьеры в архиве")]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            on: {
                              click: function ($event) {
                                _vm.hideDivUsers.archive =
                                  !_vm.hideDivUsers.archive
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.hideDivUsers.archive
                                    ? "Показать"
                                    : "Скрыть"
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                !_vm.hideDivUsers.archive
                  ? _vm._l(_vm.inactiveUsers, function (r, index) {
                      return _c("tr", [
                        _c("td", { attrs: { width: "50px" } }, [
                          _vm._v(_vm._s(index + 1)),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(r.id) +
                              ": " +
                              _vm._s(r.name) +
                              " (" +
                              _vm._s(r.login) +
                              ")"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _vm.editUser
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-xs btn-info pull-right",
                                  on: {
                                    click: function ($event) {
                                      return _vm.editUser(r)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-eye",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ])
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticClass: "division_info" }, [
      _c("td", { attrs: { colspan: "10" } }, [_vm._v("Курьеры без дивизиона")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }